import { AssetImageDto } from '@floori-web-components';

export const assetImageMapper = (image?: AssetImageDto): AssetImageDto => image || {};
